import React, { PureComponent } from 'react'
import { createPortal } from 'react-dom'
import {
  string, func, bool, oneOf,
} from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import Alert from '@active/react-ui/Alert'
import { getRootElement } from '../../../shared/utils/poperConfig'
import { requestScrollIntoView } from '../../../shared/utils/scroll'
import DOMPurify from 'dompurify'

import './ErrorContent.scss'

const ERROR_MSG_CONTAINER_ID = 'passportAppGloalErrorMsg'
const defaultError = 'passport.error.server.default'

const icons = ['success', 'warning', 'danger', 'info'] // error should be dafault to danger

class ErrorContent extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    errorMsg: string,
    messageType: string,
    autoScrollOnShow: bool,
    scrollBehavior: oneOf(['auto', 'smooth']),
    scrollBlock: oneOf(['start', 'center', 'end']),
    scrollDedupeKey: string,
  }

  static defaultProps = {
    errorMsg: undefined,
    messageType: '',
    autoScrollOnShow: false,
    scrollBehavior: 'smooth',
    scrollBlock: 'start',
    scrollDedupeKey: '',
  }

  constructor(props) {
    super(props)

    this.state = {
      target: null,
    }

    this.autoScrollFrame = null
  }

  componentDidMount() {
    this.setState({
      target: getRootElement().querySelector(`#${ERROR_MSG_CONTAINER_ID}`),
    }, () => {
      this.shouldAutoScroll() && this.queueAutoScroll()
    })
  }

  componentDidUpdate(prevProps) {
    if (this.shouldAutoScroll() && this.isErrorMsgChanged(prevProps)) {
      this.queueAutoScroll()
    }
  }

  componentWillUnmount() {
    this.clearPendingAutoScroll()
  }

  clearPendingAutoScroll = () => {
    if (this.autoScrollFrame) {
      cancelAnimationFrame(this.autoScrollFrame)
      this.autoScrollFrame = null
    }
  }

  isErrorMsgChanged = (prevProps) => {
    const { errorMsg } = this.props
    return errorMsg !== prevProps.errorMsg
  }

  shouldAutoScroll = () => {
    const { autoScrollOnShow, errorMsg } = this.props
    const { target } = this.state
    if (!autoScrollOnShow || !target || typeof errorMsg !== 'string') {
      return false
    }

    return true
  }

  queueAutoScroll = () => {
    this.clearPendingAutoScroll()

    const executeAutoScroll = () => {
      const {
        scrollBehavior,
        scrollBlock,
        scrollDedupeKey,
        errorMsg,
      } = this.props
      const { target } = this.state

      requestScrollIntoView({
        target,
        rootElement: getRootElement(),
        dedupeKey: scrollDedupeKey,
        requestKey: errorMsg,
        behavior: scrollBehavior,
        block: scrollBlock,
      })
    }

    this.autoScrollFrame = requestAnimationFrame(executeAutoScroll)
  }

  render() {
    const { messageType, errorMsg, i18n } = this.props
    const { target } = this.state
    if (target && typeof errorMsg === 'string') {
      const code = errorMsg || defaultError
      const message = decodeURIComponent(i18n(code))
      const msgType = icons.find(i => i === (messageType && messageType.toLowerCase())) || 'danger'

      const safeHtml = DOMPurify.sanitize(message, {
        ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'ul', 'li', 'br', 'span'],
        ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
      })


      console.log('safeHtml: 1', safeHtml, '1')

      return (
        createPortal((
          <Alert type={msgType} theme="inline" className="error-content">
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: safeHtml }}
            />
          </Alert>
        ), target)
      )
    }
    return null
  }
}

export default withI18n(ErrorContent)
